import React from 'react';

interface TimeHeaderProps {
    timePeriods: string[];
    timeColumns: string[];
}

// Manages the time periods and columns at the top of the calendar.
export function TimeHeader({ timePeriods, timeColumns }: TimeHeaderProps) {
    return (
        <>
            <div className="relative -top-8 flex justify-around">
                {timePeriods.map((periodName, index) => (
                    <div key={index} className="grow text-center uppercase">
                        {periodName}
                    </div>
                ))}
            </div>
            <div className="relative -left-2.5 -mt-7 flex">
                {timeColumns.map((time) => (
                    <div key={time} className="grow">
                        {time}
                    </div>
                ))}
            </div>
        </>
    );
}
